<section class="sana-auth auth-page">
  <div class="auth-card">
    <img
      src="/img/logo-without-slogan.png"
      alt="sanactivo"
      class="logo"
    />

    <h2 class="title">Anmelden</h2>
    <p class="subtitle">Login für Therapeutinnen und Therapeuten.</p>

    <form
      autocomplete="on"
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()">

      @if (!hasPasswordField) {
        <div class="step">
          <label class="field">
            <span>E-Mail-Adresse</span>
            <input
              class="input"
              id="email"
              name="email"
              type="email"
              autocomplete="email"
              autofocus
              [class.is-invalid]="loginForm.controls.email.invalid && loginForm.controls.email.touched"
              [formControl]="loginForm.controls.email"
              (keyup.enter)="enablePasswordField()" />

            @if (loginForm.controls.email.invalid && loginForm.controls.email.touched) {
              <span class="field-error">Bitte gib eine gültige E-Mail-Adresse ein.</span>
            }
          </label>

          <div class="actions">
            <button type="button" class="btn btn-primary" (click)="enablePasswordField()">Weiter</button>
          </div>
        </div>
      } @else {
        <div class="step">
          <label class="field">
            <span>Passwort</span>
            <div class="password-wrapper">
              <input
                class="input"
                id="password"
                name="password"
                autocomplete="current-password"
                autofocus
                [type]="showPassword() ? 'text' : 'password'"
                [class.is-invalid]="loginForm.controls.password.invalid && loginForm.controls.password.touched"
                [formControl]="loginForm.controls.password" />
              <button
                type="button"
                class="password-toggle"
                [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
                (click)="togglePassword()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </button>
            </div>

            @if (loginForm.controls.password.hasError('required') && loginForm.controls.password.touched) {
              <span class="field-error">Bitte gib dein Passwort ein.</span>
            }
          </label>

          @if (hasLoginErrorMessage()) {
            <div class="form-error" role="alert">
              {{ loginErrorMessage() }}
            </div>
          }

          <div class="actions">
            <button type="button" class="btn btn-secondary" (click)="disablePasswordField()">Zurück</button>
            <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
              {{ isSubmitting() ? 'Wird geprüft …' : 'Anmelden' }}
            </button>
          </div>
        </div>
      }
    </form>

    <div class="auth-links">
      <div>Noch kein Konto? <a [routerLink]="['/register']">Jetzt registrieren.</a></div>
      <a class="muted-link" [routerLink]="['/password/password-request-reset']">Passwort vergessen</a>
    </div>
  </div>

  <div class="auth-copyright">© {{ currentYear }} Sanactivo</div>
</section>
